import React from 'react';
import { PaymentIcon } from '../../Icons';
import { Nullable, SearchItemViewModel, SearchMeta } from '../types';
import { convertToBillingUrl } from '../../../nav/utils/getBillingBaseUrl';

const chipStates = {
  Draft: 'default',
  Error: 'error',
  Posted: 'success',
  Canceled: 'error',
  Voided: 'error',
  Processed: 'success',
  Processing: 'primary',
};

function renderItem(payment, t): Nullable<SearchItemViewModel> {
  return {
    title: payment['PaymentNumber'],
    descriptionFields: [
      {
        type: 'Text',
        value: payment['Account.Name'],
        title: payment['Account.Name'],
      },
      {
        type: 'Text',
        value: payment['Account.AccountNumber'],
        title: payment['Account.AccountNumber'],
      },
      {
        type: 'Date',
        value: payment['EffectiveDate'],
        title: t('Payment.PaymentDate'),
      },
      {
        type: 'Currency',
        value: payment['PaymentAmount'],
        title: t('Payment.PaymentTotal'),
        currency: payment['Currency.Code'],
      },
    ],
    chipField: {
      state: chipStates[payment['Status']],
      label: t(`Payment.Status.${payment['Status']}`),
    },
    href: convertToBillingUrl(
      `/apps/NewPayment.do?method=view&id=${payment.Id}`,
    ),
  };
}

export const Payment: SearchMeta = {
  objectType: 'Payment',
  objectLabelI18n: 'Payment.TabLabel',
  needsPermission: false,
  tabIcon: <PaymentIcon />,
  listPageUrl: convertToBillingUrl('/apps/NewPayment.do?method=list'),
  hasAdvancedSearch: true,
  renderItem,
};
